export default "__VITE_ASSET__CScaItwe__"